import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckBoxComponent } from './atoms/checkbox';
import { ColorComponent } from './atoms/color';
import { DateComponent } from './atoms/date';
import { DropDownComponent } from './atoms/dropdown';
import { FileComponent } from './atoms/file';
import { FileInputComponent } from './atoms/fileInput';
import { StarRatingComponent } from './atoms/stars';
import { TextareaComponent } from './atoms/textaerea';
import { TextBoxComponent } from './atoms/textbox';
import { DynamicFormBuilderComponent } from './dynamic-form-builder.component';
import { FieldBuilderComponent } from './field-builder/field-builder.component';


/**
 * Modulo de formulario dinamico
 */
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  declarations: [
    DynamicFormBuilderComponent,
    FieldBuilderComponent,
    FileInputComponent,
    TextBoxComponent,
    ColorComponent,
    DropDownComponent,
    DateComponent,
    CheckBoxComponent,
    FileComponent,
    TextareaComponent,
    StarRatingComponent
  ],
  exports: [DynamicFormBuilderComponent, FileComponent, FieldBuilderComponent],
  providers: []
})
export class DynamicFormBuilderModule { }
